import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  fees: []
};

const slice = createSlice({
  name: 'fee',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getFeesSuccess(state, action) {
      state.isLoading = false;
      state.fees = action.payload;
    }
  }
});

export default slice.reducer;

export function getFees(idDivision) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/division/obtener-division-saldo', {
        id_division: idDivision
      });
      dispatch(slice.actions.getFeesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
